import { kramerMediaArray } from './kramerMedia'
import { kramerBio } from './kramerBios'
import { georgeProfileReviewHinge, jerryProfileReviewBumble, elaineProfileReviewTinder } from './kramerProfileReviews'

export const kramerDatingProfileHinge = {
  _id: 'kramerDatingProfileHingeId',
  userId: 'kramerUserId',
  email: 'kramer@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: kramerMediaArray[0]._id,
      mediaItemURL: kramerMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[0].type,
      caption: kramerMediaArray[0].captions[0],
      subcaption: kramerMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[1]._id,
      mediaItemURL: kramerMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[1].type,
      caption: kramerMediaArray[1].captions[0],
      subcaption: kramerMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[2]._id,
      mediaItemURL: kramerMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[2].type,
      caption: kramerMediaArray[2].captions[0],
      subcaption: kramerMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[16]._id,
      mediaItemURL: kramerMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[16].type,
      caption: kramerMediaArray[16].captions[0],
      subcaption: kramerMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[11]._id,
      mediaItemURL: kramerMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[11].type,
      caption: kramerMediaArray[11].captions[0],
      subcaption: kramerMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[14]._id,
      mediaItemURL: kramerMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[14].type,
      caption: kramerMediaArray[14].captions[0],
      subcaption: kramerMediaArray[14].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: kramerBio._id,
    vitalInfo: { ...kramerBio.vitalInfo },
    prompts: [
      { ...kramerBio.prompts[0] },
      { ...kramerBio.prompts[1] },
      { ...kramerBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...georgeProfileReviewHinge }
  ],
  mediaItems: [ ...kramerMediaArray ],
  bioItems: { ...kramerBio },
}

export const kramerDatingProfileBumble = {
  _id: 'kramerDatingProfileBumbleId',
  userId: 'kramerUserId',
  email: 'kramer@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: kramerMediaArray[0]._id,
      mediaItemURL: kramerMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[0].type,
      caption: kramerMediaArray[0].captions[0],
      subcaption: kramerMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[1]._id,
      mediaItemURL: kramerMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[1].type,
      caption: kramerMediaArray[1].captions[0],
      subcaption: kramerMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[2]._id,
      mediaItemURL: kramerMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[2].type,
      caption: kramerMediaArray[2].captions[0],
      subcaption: kramerMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[16]._id,
      mediaItemURL: kramerMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[16].type,
      caption: kramerMediaArray[16].captions[0],
      subcaption: kramerMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[11]._id,
      mediaItemURL: kramerMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[11].type,
      caption: kramerMediaArray[11].captions[0],
      subcaption: kramerMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[14]._id,
      mediaItemURL: kramerMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[14].type,
      caption: kramerMediaArray[14].captions[0],
      subcaption: kramerMediaArray[14].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: kramerBio._id,
    vitalInfo: { ...kramerBio.vitalInfo },
    prompts: [
      { ...kramerBio.prompts[0] },
      { ...kramerBio.prompts[1] },
      { ...kramerBio.prompts[2] }
    ],
    aboutMe: kramerBio.aboutMe[0],
    hobbies: [kramerBio.hobbies[0], kramerBio.hobbies[1], kramerBio.hobbies[2], kramerBio.hobbies[3], kramerBio.hobbies[4] ],
  },
  profileReviews: [
    { ...jerryProfileReviewBumble }
  ],
  mediaItems: [ ...kramerMediaArray ],
  bioItems: { ...kramerBio },
}

export const kramerDatingProfileTinder = {
  _id: 'kramerDatingProfileTinderId',
  userId: 'kramerUserId',
  email: 'kramer@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: kramerMediaArray[0]._id,
      mediaItemURL: kramerMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[0].type,
      caption: kramerMediaArray[0].captions[0],
      subcaption: kramerMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[1]._id,
      mediaItemURL: kramerMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[1].type,
      caption: kramerMediaArray[1].captions[0],
      subcaption: kramerMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[2]._id,
      mediaItemURL: kramerMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[2].type,
      caption: kramerMediaArray[2].captions[0],
      subcaption: kramerMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[16]._id,
      mediaItemURL: kramerMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[16].type,
      caption: kramerMediaArray[16].captions[0],
      subcaption: kramerMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[11]._id,
      mediaItemURL: kramerMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[11].type,
      caption: kramerMediaArray[11].captions[0],
      subcaption: kramerMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: kramerMediaArray[14]._id,
      mediaItemURL: kramerMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: kramerMediaArray[14].type,
      caption: kramerMediaArray[14].captions[0],
      subcaption: kramerMediaArray[14].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: kramerBio._id,
    vitalInfo: { ...kramerBio.vitalInfo },
    prompts: [
      { ...kramerBio.prompts[0] },
      { ...kramerBio.prompts[1] },
      { ...kramerBio.prompts[2] }
    ],
    aboutMe: kramerBio.aboutMe[0],
    hobbies: [kramerBio.hobbies[0], kramerBio.hobbies[1], kramerBio.hobbies[2], kramerBio.hobbies[3], kramerBio.hobbies[4] ],
  },
  profileReviews: [
    { ...elaineProfileReviewTinder }
  ],
  mediaItems: [ ...kramerMediaArray ],
  bioItems: { ...kramerBio },
}